// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3tibI","unreadBadge":"styles_unreadBadge__2g1p6","modalContent":"styles_modalContent__2ivDU","modal":"styles_modal__1oOR-"};